module.exports = __webpack_public_path__ + "img/analyse-svgrepo-com.0143ad54.svg";